import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import VehicleCategoryDrawer from "components/drawer/VehicleCategoryDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

const VehicleCategoryTable = ({
  vehicleCategory,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <VehicleCategoryDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {vehicleCategory?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="font-semibold uppercase text-xs text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data["vehcilecategory"]}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data["name"]}
            </TableCell>
            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  title={data["Vehicle Model"]}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  // hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default VehicleCategoryTable;
